import { useState } from "react";
import { toast } from "sonner";
import { RefreshCw, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const RelocRates = () => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/relocation/tools/refresh-rates");
      toast.success(`Updating ${data.guides} guide${data.guides === 1 ? "" : "s"} to today's exchange rate. Downloads are repackaged in the background over the next few minutes.`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="border border-[#E2D9CC] bg-[#FAF7F2] p-7 flex flex-wrap items-center gap-4" data-testid="reloc-rates">
      <div className="mr-auto max-w-2xl">
        <p className="eyebrow mb-2 flex items-center gap-2"><RefreshCw className="w-4 h-4" strokeWidth={1.5} />Exchange rates</p>
        <p className="text-sm text-[#1C181D]">Put today's European Central Bank rate into every guide's spreadsheets and phone calculators, then repackage the downloads. No AI is used.</p>
      </div>
      <Button data-testid="reloc-rates-refresh-all" onClick={go} disabled={busy} className="rounded-none">{busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}Update all spreadsheets</Button>
    </div>
  );
};
